/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const XTwitter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/X Twitter"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M9.492 12.576 2 3h5.934l4.625 5.919L17.5 3.027h3.269l-6.63 7.914L22 21h-5.917l-5.008-6.4-5.346 6.382H2.443zm7.454 6.65L5.639 4.774H7.07l11.293 14.452z"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const XTwitterIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'x-twitter-icon'}
      icon={XTwitter}
      {...props}
      size={size}
    />
  );
};
